/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopifyAppStoredSessionDto } from '../../models/shopify-app-stored-session-dto';

export interface ShopifyAppControllerGetSession$Params {
  shopifySessionId: string;

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
}

export function shopifyAppControllerGetSession(http: HttpClient, rootUrl: string, params: ShopifyAppControllerGetSession$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopifyAppStoredSessionDto>> {
  const rb = new RequestBuilder(rootUrl, shopifyAppControllerGetSession.PATH, 'get');
  if (params) {
    rb.path('shopifySessionId', params.shopifySessionId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopifyAppStoredSessionDto>;
    })
  );
}

shopifyAppControllerGetSession.PATH = '/api/v1/shopify-app/sessions/{shopifySessionId}';
